<template>
  <qx-card-form title="收入信息">
    <qx-custom-form :noSubBtn="true"
                    ref="baseForm"
                    :formData="baseForm"
                    labelWidth="120px">
      <section slot="split"></section>
      <div slot="computeResult"
           class="warn-tips">
        <span class="error"
              v-if="computeResult && computeResult.estimateIncomeFee === 0">收入计算失败，没有匹配到已有线路</span>
      </div>
      <div slot="recive"
           slot-scope="prop">
        <div v-show="
            prop.form.balanceType === '1' || prop.form.balanceType === '2'
          ">
          离场日期+
          <el-input class="inputBox1"
                    v-model="otherFormData.reciveTime"
                    placeholder="请输入">
            <span slot="suffix"
                  class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '3'">
          <el-input class="appendInputBox"
                    v-model="otherFormData.reciveMonth"
                    placeholder="请输入">
            <span slot="suffix">
              个月后
              <el-select class="inputAppendSelect"
                         v-model="otherFormData.reciveTimeDay"
                         :clear="true"
                         placeholder="请选择">
                <el-option v-for="item in 31"
                           :key="item"
                           :label="item + '号'"
                           :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <div slot="collection"
           slot-scope="prop">
        <div v-show="prop.form.balanceType === '2'">
          回单审核后+
          <el-input class="inputBox2"
                    v-model="otherFormData.collectionTime"
                    placeholder="请输入">
            <span slot="suffix"
                  class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '3'">
          <el-input class="appendInputBox"
                    v-model="otherFormData.collectionMonth"
                    placeholder="请输入">
            <span slot="suffix">
              个月后
              <el-select class="inputAppendSelect"
                         v-model="otherFormData.collectionTimeDay"
                         :clear="true"
                         placeholder="请选择">
                <el-option v-for="item in 31"
                           :key="item"
                           :label="item + '号'"
                           :value="item" />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <!-- 收入单价 -->
      <section slot="priceUnit"
               slot-scope="prop">
        <el-input v-model="prop.form.priceUnit"
                  class="inputBox"
                  placeholder="请输入金额"
                  @blur="calCostPrice">
          <el-select class="inputAppendSelect"
                     slot="suffix"
                     v-model="prop.form.priceEnum"
                     :clear="true"
                     @change="calCostPrice">
            <!-- 单位 -->
            <el-option v-for="item in baseForm.priceEnumOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value" />
          </el-select>
        </el-input>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
import { getCostPrice, getPrePayCashAndAfterPayCash } from './calc';
export default {
  data () {
    return {
      // 计算结果
      computeResult: null,
      otherFormData: {
        reciveTime: '', // 回单期限天数
        reciveMonth: '', // 回单期限第几个月
        reciveTimeDay: '', // 回单期限第几号
        collectionTime: '', // 收款期限天数
        collectionMonth: '', // 收款期限第几个月
        collectionTimeDay: '', // 收款期限第几号
      },
      baseForm: {
        balanceTypeOptions: [],
        priceEnumOptions: [],
        inline: true,
        form: [
          {
            label: '预估收入',
            value: 'costPrice',
            type: 'input',
            default: '0',
            readonly: true,
            unit: '元',
          },
          {
            label: '收入单价',
            value: 'priceUnit',
            slot: true,
          },
          {
            value: 'computeResult',
            allCustom: true,
          },
          {
            value: 'split',
            allCustom: true,
          },
          {
            label: '收入单价',
            value: 'priceEnum',
            type: 'input',
            default: '0',
            hide: true,
          },
          {
            label: '预付现金',
            value: 'prePayCash',
            type: 'input',
            default: '0',
            unit: '元',
            onChange: () => {
              this.handlePrePayCashChange();
            },
          },
          {
            label: '尾款现金',
            value: 'afterPayCash',
            type: 'input',
            default: '0',
            unit: '元',
            onChange: () => {
              this.handleAfterPayCashChange();
            },
          },
          {
            value: 'split',
            allCustom: true,
          },
          {
            label: '结算方式',
            value: 'balanceType',
            type: 'select',
            width: '240px',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '回单期限',
            value: 'recive',
            slot: true,
          },
          {
            label: '收款期限',
            value: 'collection',
            slot: true,
            hide: false,
          },
        ],
        rules: {
          balanceType: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async getOptions () {
      if (!this.baseForm.balanceTypeOptions.length) {
        const enumList = await getEnumList({
          codeType: 'BALANCE_TYPE,PRICE_ENUM',
        });
        this.baseForm.balanceTypeOptions = enumList[0];
        this.baseForm.priceEnumOptions = enumList[1];
      }
    },
    // 计算预估收入
    calCostPrice () {
      const priceEnum = Number(this.$refs.baseForm.getVal('priceEnum'));
      const priceUnit = Number(this.$refs.baseForm.getVal('priceUnit'));
      const weight = Number(this.computeResult.totalProductWeight);
      const square = Number(this.computeResult.totalProductVolume);
      const cmMileage = parseFloat(this.computeResult.totalMileage);

      const preCostPrice = this.$refs.baseForm.getVal('costPrice');
      const costPrice = getCostPrice({ priceEnum, priceUnit, weight, square, cmMileage });
      this.$refs.baseForm.setVal('costPrice', costPrice);

      if (Number(preCostPrice) !== Number(costPrice)) {
        const prePayCash = Number(this.$refs.baseForm.getVal('prePayCash'));
        const afterPayCash = Number(this.$refs.baseForm.getVal('afterPayCash'));
        const balanceType = Number(this.$refs.baseForm.getVal('balanceType'));
        const changeType = 1;
        const afterCalcPrice = getPrePayCashAndAfterPayCash({
          costPrice,
          prePayCash,
          afterPayCash,
          balanceType,
          changeType,
        });
        this.$refs.baseForm.setVal('costPrice', afterCalcPrice.costPrice);
        this.$refs.baseForm.setVal('prePayCash', afterCalcPrice.prePayCash);
        this.$refs.baseForm.setVal('afterPayCash', afterCalcPrice.afterPayCash);
      }
    },
    // 计算尾款现金
    handlePrePayCashChange () {
      const costPrice = Number(this.$refs.baseForm.getVal('costPrice'));
      const prePayCash = Number(this.$refs.baseForm.getVal('prePayCash'));
      const afterPayCash = Number(costPrice - prePayCash);
      this.$refs.baseForm.setVal('afterPayCash', afterPayCash);
    },
    // 计算预付现金
    handleAfterPayCashChange () {
      const costPrice = Number(this.$refs.baseForm.getVal('costPrice'));
      const afterPayCash = Number(this.$refs.baseForm.getVal('afterPayCash'));
      const prePayCash = Number(costPrice - afterPayCash);
      this.$refs.baseForm.setVal('prePayCash', prePayCash);
    },
    // 计算完成
    setComputeInfo (data) {
      if (data && Object.keys(data).length) {
        this.computeResult = data;
        this.calCostPrice();
      }
    },

    setValueFromCustomer (data) {
      this.$refs.baseForm.setVal('balanceType', data.payWay);
      this.otherFormData = {
        reciveTime: data ? data.reciveTime : '', // 回单期限天数
        reciveMonth: data ? (data.reciveMonth || data.reciveTime) : '', // 回单期限第几个月
        reciveTimeDay: data ? (data.reciveDay || data.reciveDay) : '', // 回单期限第几号
        collectionTime: data ? data.collectionTime : '', // 收款期限天数
        collectionMonth: data ? (data.collectionMonth || data.collectionTime) : '', // 收款期限第几个月
        collectionTimeDay: data ? (data.collectionDay || data.collectionDay) : '', // 收款期限第几号
      };
      this.handleLabelTypeChange();
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证回单期限
     */
    checkRecive (rule, value, call) {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      if ((balanceType === '1' || balanceType === '2') && !this.otherFormData.reciveTime) {
        call('请输入回单期限天数');
      } else if (balanceType === '3' && (!this.otherFormData.reciveMonth || !this.otherFormData.reciveTimeDay)) {
        call('请输入回单期限天数');
      } else {
        call();
      }
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证收款期限
     */
    checkCollection (rule, value, call) {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      if (balanceType === '2' && !this.otherFormData.collectionTime) {
        call('请输入收款期限天数');
      } else if (balanceType === '3' && (!this.otherFormData.collectionMonth || !this.otherFormData.collectionTimeDay)) {
        call('请输入收款期限天数');
      } else {
        call();
      }
    },
    handleLabelTypeChange () {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      let isNotAuto = balanceType === '1';
      const tar = ['collection'];
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          balanceType: formData.balanceType,
          costPrice: formData.costPrice,
          priceUnit: formData.priceUnit,
          priceEnum: formData.priceEnum,
          prePayCash: formData.prePayCash,
          afterPayCash: formData.afterPayCash,
          payWay: formData.balanceType,
          computeResult: this.computeResult,
          ...this.otherFormData,
        };
      }
      return formData;
    },

    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },

    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        delete formData.computeResult;
        let customerInfo = {};
        if (`${formData.balanceType}` === '3') {
          formData.collectionTime = formData.collectionMonth;
          formData.reciveTime = formData.reciveMonth;
        }
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            if (
              name === 'costPrice' ||
              name === 'prePayCash' ||
              name === 'afterPayCash' ||
              name === 'priceUnit' ||
              name === 'priceEnum'
            ) {
              customerInfo[`customerInfo.${name}`] = formData[name];
            } else if (name === 'collectionTimeDay') {
              customerInfo['customerInfo.incomeBalanceData.collectionDay'] = formData[name];
            } else if (name === 'reciveTimeDay') {
              customerInfo['customerInfo.incomeBalanceData.reciveDay'] = formData[name];
            } else {
              customerInfo['customerInfo.incomeBalanceData.' + name] = formData[name];
            }
          }
        }
        formData = customerInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.orderFee) {
        data.costPrice = data.orderFee.costPrice / 100;
        data.prePayCash = data.orderFee.prePayCash / 100;
        data.afterPayCash = data.orderFee.afterPayCash / 100;
        data.priceUnit = data.orderFee.priceUnit;
        data.priceEnum = data.orderFee.priceEnum;
      }

      if (data.incomePaymentDaysInfo) {
        data.payWay = data.incomePaymentDaysInfo.balanceType;
        if (data.payWay === 1) {
          data.reciveTime = data.incomePaymentDaysInfo.reciveTime;
        }
        if (data.payWay === 2) {
          data.reciveTime = data.incomePaymentDaysInfo.reciveTime;
          data.collectionTime = data.incomePaymentDaysInfo.collectionTime;
        }
        if (data.payWay === 3) {
          data.reciveMonth = data.incomePaymentDaysInfo.reciveMonth;
          data.reciveDay = data.incomePaymentDaysInfo.reciveDay;
          data.collectionMonth = data.incomePaymentDaysInfo.collectionMonth;
          data.collectionDay = data.incomePaymentDaysInfo.collectionDay;
        }
      }
    },
    async init (data = {}) {
      await this.getOptions();

      this.setDetailData(data);

      this.computeResult = data.computeResult || null;

      let balanceType = this.baseForm.balanceTypeOptions[0].value;
      if (data.payWay !== undefined) {
        data.balanceType = String(data.payWay);
      } else {
        data.balanceType = balanceType;
      }

      if (data.priceEnum !== undefined) {
        data.priceEnum = String(data.priceEnum);
      } else {
        data.priceEnum = this.baseForm.priceEnumOptions[0].value;
      }

      if (data.priceUnit === undefined) {
        data.priceUnit = '0';
      }

      if (data.costPrice === undefined) {
        data.costPrice = '0';
      }

      if (data.prePayCash === undefined) {
        data.prePayCash = '0';
      }

      if (data.afterPayCash === undefined) {
        data.afterPayCash = '0';
      }

      this.otherFormData = {
        reciveTime: data ? data.reciveTime : '', // 回单期限天数
        reciveMonth: data ? (data.reciveMonth || data.reciveTime) : '', // 回单期限第几个月
        reciveTimeDay: data ? (data.reciveTimeDay || data.reciveTimeDay) : '', // 回单期限第几号
        collectionTime: data ? data.collectionTime : '', // 收款期限天数
        collectionMonth: data ? (data.collectionMonth || data.collectionTime) : '', // 收款期限第几个月
        collectionTimeDay: data ? (data.collectionTimeDay || data.collectionTimeDay) : '', // 收款期限第几号
      };
      this.$refs.baseForm.setVal(data);
      this.handleLabelTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
.inputBox1 {
  width: 172px;
}
.inputBox2 {
  width: 158px;
}
.warn-tips {
  height: 32px;
  line-height: 32px;
  margin-left: 40px;
}
</style>
